import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, SxProps, Theme, Typography } from '@mui/material';

import { FIT_LEVEL_FILLS, FIT_LEVELS } from '../compare.util';

const STRINGS = appStrings.modules.myColleges.compare.legend;
const DOT_FILLS = { ...FIT_LEVEL_FILLS, strong: 'Brand/400' } as const;

export const FitLegend = () => (
  <Box id="compare-fit-legend" sx={legendSx}>
    {FIT_LEVELS.map((level) => (
      <Box key={level} sx={seriesSx}>
        <Box
          sx={({ backrs }) => ({
            width: backrs.spacing['spacing-lg'],
            height: backrs.spacing['spacing-lg'],
            borderRadius: backrs.radius['radius-full'],
            border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
            backgroundColor: backrs.colors[DOT_FILLS[level]],
          })}
        />
        <Typography variant="text-sm-regular" sx={labelSx}>
          {STRINGS[level]}
        </Typography>
      </Box>
    ))}
  </Box>
);

const legendSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
  gap: backrs.spacing['spacing-lg'],
});

const seriesSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-sm'],
});

const labelSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});
